import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';
import { IResponseUserPalmetto } from 'interfaces/userPalmetto.interface';

export interface IFetchPalmettoUsersState {
  state: QueryState;
  users: IResponseUserPalmetto[] | [];
  error: Nullable<string>;
  accessToken: string | undefined;
}

export const FetchPalmettoUsersEmptyState: IFetchPalmettoUsersState = {
  state: QueryState.UNDEFINED,
  users: [],
  error: null,
  accessToken: undefined
};
